<template>
    <!-- 登录提示  -->
    <div class="popup-share-tips" v-if="popShow" :class="[lang]">
        <p v-html="$t('popup.shareTips')"></p>
        <div class="popup-tips-arrow"></div>
    </div>
</template>

<script>
export default {
    name: 'popup-share-tips',
    computed: {
        popShow() {
            return this.$store.state.popup.shareTips;
        },
        commText() {
            return this.$store.state.commText;
        },
        lang() {
            return this.$store.state.lang;
        }
    },
    methods: {}
};
</script>

<style lang="less" scoped>
.popup-share-tips {
    width: 270px;
    background: url(~@/assets/img/pop_sm_repeat.png) center/100% 100% repeat-y;
    max-height: 300px;
    min-height: 120px;
    // margin: auto;
    position: absolute;
    right: 7px;
    // left: 50%;
    // margin-left: -135px;
    bottom: 98px;
    z-index: 1;
    padding-top: 6px;
    box-sizing: border-box;

    // &.ru {
    //     width: 441px;
    //     background: url(~@/assets/img/pop_mid_repeat.png) center/100% 100%
    //         repeat-y;

    //     &::before {
    //         content: '';
    //         width: 441px;
    //         height: 26px;
    //         background: url(~@/assets/img/pop_mid_top.png) center/100% 100%
    //             no-repeat;
    //         position: absolute;
    //         top: -22px;
    //         left: 0;
    //     }
    //     &::after {
    //         content: '';
    //         width: 441px;
    //         height: 19px;
    //         background: url(~@/assets/img/pop_mid_bottom.png) center/100% 100%
    //             no-repeat;
    //         position: absolute;
    //         bottom: -17px;
    //         left: 0;
    //     }
    // }

    p {
        text-align: center;
        font-size: 24px;
        line-height: 2;
        color: #9c9273;

        &.ru {
            font-size: 18px;
        }
    }

    // &.ru {
    //     padding-top: 28px;
    //     p {
    //         font-size: 24px;
    //     }
    // }

    .popup-tips-arrow {
        width: 42px;
        height: 48px;
        position: absolute;
        bottom: -72px;
        left: 50%;
        margin-left: 10px;
        background: url(~@/assets/img/tips_arr.png) center/100% 100% no-repeat;
        animation: 0.6s ease-in-out infinite alternate-reverse tipsAni;

        @keyframes tipsAni {
            from {
                transform: translateY(0);
            }
            to {
                transform: translateY(5px);
            }
        }
    }

    &::before {
        content: '';
        width: 270px;
        height: 25px;
        background: url(~@/assets/img/pop_sm_top.png) center/100% 100% no-repeat;
        position: absolute;
        top: -22px;
        left: 0;
    }
    &::after {
        content: '';
        width: 270px;
        height: 19px;
        background: url(~@/assets/img/pop_sm_bottom.png) center/100% 100%
            no-repeat;
        position: absolute;
        bottom: -17px;
        left: 0;
    }
}
</style>
